<div class="min-h-screen bg-white">
  <div class="flex flex-col min-h-screen lg:flex-row">
    <!-- Partie gauche avec image - Pleine hauteur -->
    <div class="relative flex flex-col items-center justify-center w-full bg-white lg:w-1/2">
      <!-- Image principale centrée -->
      <div class="flex flex-col items-center justify-center flex-1 w-full p-8">
         <h1 class="mb-4 text-4xl font-bold tracking-wider text-center text-blue-800">CERTIPORT</h1>
        <div class="w-full max-w-lg">
          <img src="assets/image.png" alt="OPRAG Port" class="object-contain w-full h-auto rounded-lg shadow-lg">
        </div>
      </div>
    </div>

    <!-- Partie droite avec formulaire - Image d'arrière-plan -->
    <div class="relative flex items-center justify-center w-full overflow-hidden bg-center bg-cover lg:w-1/2"
      style="background-image: url('assets/arrierePlan.png');">
      <!-- Overlay sombre pour améliorer la lisibilité -->
      <div class="absolute inset-0 bg-black opacity-30"></div>

      <!-- Conteneur du formulaire -->
      <div class="relative z-10 w-full max-w-md p-8">
        <!-- Formulaire principal de connexion -->
        <form [ngClass]="{'animate-slide-in-right': currentStep === 1, 'hidden': currentStep !== 1}" class="w-full">

          <h2 class="mb-3 text-3xl font-bold text-white">PORTAIL DE CONNEXION</h2>
          <p class="mb-8 text-sm text-blue-100">Veuillez vous identifier pour accéder à la plateforme CERTIPORT</p>

          <div class="mb-6">
            <label for="username" class="block mb-2 text-sm font-medium text-white">
              Nom d'utilisateur
            </label>
            <input type="text" id="username" name="username" [(ngModel)]="username"
              class="block w-full p-3 text-lg text-gray-900 bg-white border-0 rounded-lg focus:ring-2 focus:ring-blue-300 focus:outline-none"
              placeholder="user@name" required />
          </div>

          <div class="mb-6">
            <label for="password" class="block mb-2 text-sm font-medium text-white">
              Mots de passe
            </label>
            <div class="relative">
              <input [type]="showPassword ? 'text' : 'password'" id="password" name="password" [(ngModel)]="motDePasse"
                placeholder="••••••••"
                class="block w-full p-3 pr-10 text-lg text-gray-900 bg-white border-0 rounded-lg focus:ring-2 focus:ring-blue-300 focus:outline-none"
                required />
              <button type="button" (click)="togglePasswordVisibility()"
                class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-600 hover:text-gray-800">
                <svg *ngIf="!showPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                <svg *ngIf="showPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                </svg>
              </button>
            </div>
          </div>

          <button type="submit" (click)="login()"
            class="w-full px-5 py-3 text-lg font-medium text-center text-blue-600 transition-colors duration-200 bg-white rounded-lg hover:bg-blue-50 focus:ring-4 focus:outline-none focus:ring-blue-300">
            Se Connecter
          </button>

          <div class="mt-6 text-right">
            <button type="button" (click)="goToStep(2)"
              class="text-sm text-blue-100 transition-colors duration-200 hover:text-white">
              Mots de passe oublié?
            </button>
          </div>

          <div class="mt-8 text-center">
            <p class="text-xs leading-relaxed text-blue-100">
              2025 CERTIPORT Tous droits réservés . Politique de confidentialité . Condition d'utilisation
            </p>
          </div>
        </form>

        <!-- Formulaire OTP -->
        <form [ngClass]="{'animate-slide-in-right': currentStep === 2, 'hidden': currentStep !== 2}" class="w-full">

          <h2 class="mb-8 text-3xl font-bold text-white">Vérification</h2>

          <div class="mb-6">
            <label for="otp" class="block mb-2 text-sm font-medium text-white">
              Code OTP
            </label>
            <input type="text" id="otp" name="otp" [(ngModel)]="otpCode"
              class="block w-full p-3 text-lg text-gray-900 bg-white border-0 rounded-lg focus:ring-2 focus:ring-blue-300 focus:outline-none"
              placeholder="Entrez le code reçu" required />
          </div>

          <div class="mb-6 text-right">
            <button type="button" (click)="goToStep(1)"
              class="text-sm text-blue-100 transition-colors duration-200 hover:text-white">
              Retour à la connexion
            </button>
          </div>

          <button type="button" (click)="verifyOtp()"
            class="w-full px-5 py-3 text-lg font-medium text-center text-blue-600 transition-colors duration-200 bg-white rounded-lg hover:bg-blue-50 focus:ring-4 focus:outline-none focus:ring-blue-300">
            Vérifier le code
          </button>
        </form>
      </div>
    </div>
  </div>
</div>